module.exports = __webpack_public_path__ + "static/media/nina_lunginbühl_mood.4abd70c3.jpg";